(function() {
    'use strict';

    angular
        .module("showcaseApp")
        .component("styledRadioCardButton", {
            templateUrl: "app/components/styled-radio-card-button/styled-radio-card-button.html",
            controller: StyledRadioCardButtonController,
            bindings: {
                model: "=",
                name: "@",
                listClass: "@",
                cardClass: "@",
                required: "<",
                errors: "<",
                form: "<",
                onChange: "&",
                readonly: "<",
                items: "=",
                actions: "<",
                selectionMode: "@",
                onCheckboxChange: "&?",
                iconActiveBg: "@",
                iconActiveColor: "@"
            },
            transclude: true
        })
        .directive("inputChange", function () {
            return {
                restrict: "A",
                link: function (scope, elem, attrs) {
                    scope.$watch(attrs["ngModel"], function (v) {
                        if (scope && scope.$ctrl && scope.$ctrl.onChange) {
                            scope.$ctrl.onChange({ value: v });
                        }
                    });
                },
            };
        });

    /** @ngInject */
    function StyledRadioCardButtonController() {
        var $ctrl = this;

        $ctrl.$onInit = function() {
            $ctrl.readonly = $ctrl.readonly || false;
            $ctrl.cardClass = $ctrl.cardClass || 'col-md-3 col-sm-12';
            $ctrl.isCheckboxMode = $ctrl.selectionMode === 'checkbox';
        };
    }
})();
